import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LabSupplyEditor from './LabSupplyEditor';
import LoadingDots from '../../shared/LoadingDots';
import { fetchLabSupplies, saveLabSupply } from '../../../ReduxSlices/LabSupplies/labSupplySlice';

const LabSupplyFormPage = ({ navigateTo, editingItem }) => {
  const dispatch = useDispatch();
  const { labSupplies, loading, submitting, fetched } = useSelector((state) => state.labSupplies);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUser(storedUser);
  }, []);

  useEffect(() => {
    if (!fetched) {
      dispatch(fetchLabSupplies());
    }
  }, [dispatch, fetched]);

  const handleSubmit = async (form) => {
    try {
      await dispatch(
        saveLabSupply({
          lab_supply: form,
          id: editingItem?.id,
        })
      ).unwrap();
      navigateTo('lab_supplies_list');
    } catch (err) {
      console.error('Failed to save lab supply:', err);
      alert('Failed to save lab supply. Please try again.');
    }
  };

  if (loading) return <LoadingDots />;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <LabSupplyEditor
        onSubmit={handleSubmit}
        onCancel={() => navigateTo('lab_supplies_list')}
        submitting={submitting}
        isEditing={!!editingItem}
        initialData={editingItem || null}
      />
    </div>
  );
};

export default LabSupplyFormPage;
